import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import { TabInterface } from "./TabInterface";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";


export default function ReportView() {
	const location = useLocation();
	const [searchParams] = useSearchParams(); // fallback only

	// Normalize to arrays (prefer state, fallback to URL if user refreshed/shared link)
	const courses = React.useMemo(() => {
		if (location.state?.cname && Array.isArray(location.state.cname)) {
			return location.state.cname;
		}
		if (location.state?.cname && typeof location.state.cname === "string") {
			return location.state.cname.split(",").filter(Boolean);
		}
		const url = searchParams.get("cname");
		return url ? url.split(",").filter(Boolean) : [];
	}, [location.state, searchParams]);

	const reqIDs = React.useMemo(() => {
		if (location.state?.reqID && Array.isArray(location.state.reqID)) {
			return location.state.reqID.map(String);
		}
		if (location.state?.reqID && typeof location.state.reqID === "string") {
			return location.state.reqID.split(",").filter(Boolean);
		}
		const url = searchParams.get("reqID");
		return url ? url.split(",").filter(Boolean) : [];
	}, [location.state, searchParams]);

	const [value, setValue] = React.useState("1");
	const handleChange = (_e, newValue) => setValue(newValue);

	// Ensure selected tab stays valid if data changes
	React.useEffect(() => {
		if (courses.length === 0) return;
		const maxIndex = String(courses.length);
		if (Number(value) < 1 || Number(value) > Number(maxIndex)) {
			setValue("1");
		}
	}, [courses, value]);

	const hasData = courses.length > 0 && reqIDs.length > 0;

	// Optional: warn if lengths don't match
	const lengthMismatch = hasData && courses.length !== reqIDs.length;


	return (
		<Box className="flex md:flex-row flex-col">
			<TabContext value={value}>
				<Box sx={{ width: "370px",minHeight:'100vh',
						// borderRight: 2, borderColor: "divider", 
						backgroundColor: "#F5F5F5",
					}}>
					{!hasData ? (
						<Typography sx={{ px: 2, py: 1.5 }} color="text.secondary">
							No report data found. Try navigating here from the previous page again.
						</Typography>
					) : (
						<>
							{lengthMismatch && (
								<Typography sx={{ px: 2, py: 1 }} color="warning.main">
									Note: course and requirement counts don’t match ({courses.length} vs{" "}
									{reqIDs.length}).
								</Typography>
							)}
							{/* <Tabs onChange={handleChange} value={value} orientation="vertical"> */}
							<Tabs onChange={handleChange} value={value} orientation="vertical"
								sx={(theme) => ({
									"& .MuiTabs-indicator": {
										left: 0,
										width: 5,
									},
									"& .MuiTab-root.Mui-selected": {
										backgroundColor: "color-mix(in srgb, currentColor 10%, transparent)",
									},
								})}
							>
								{courses.map((course, index) => (
									<Tab label={course} value={String(index + 1)} key={`${course}-${index}`} />
								))}
							</Tabs>
						</>
					)}
				</Box>

				{hasData &&
					reqIDs.map((reqID, index) => (
						<TabPanel
							value={String(index + 1)}
							className="md:w-9/10 w-full"
							key={`${reqID}-${index}`}
						>
							<TabInterface classRequisition={reqID} />
						</TabPanel>
					))}
			</TabContext>
		</Box>
	);
}
